import { KullaniciType } from './../models/KullaniciType';

import * as moment from 'moment'
import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ActionSheetController, Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { NL_ProgramAyarlari } from '../models/NL_ProgramAyarlari';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { NL_Servis } from '../models/NL_Servis';
declare var require: any;
let { json2excel } = require('js2excel');

@Injectable()
export class Ortak {


  static sqlType = "web";
  static timerOrtak: any;
  static dilKaynaklari = {};

  constructor(
  
    public alert?: AlertController,
    public loadingCtrl?: LoadingController,
    public actionSheet?: ActionSheetController,
    public toastCtrl?: ToastController,
    public platform?: Platform) {
    // this.nativeAudio.preloadSimple("1", 'assets/audio/Super_Ringtone.mp3');
  }

  turkishToLower(deger) {
    var letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
    deger = deger.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) { return letters[letter]; })
    return deger.toLowerCase();
  }
  public tarih(tarih: Date, format = "YYYY-MM-DD") {
    return moment(tarih).locale("tr").format(format);
  }
  public tarih2(tarih: Date, format = "DD-MM-YYYY HH:mm") {
    return moment(tarih).locale("tr").format(format);
  }

  createGuid() {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
      this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }
  
  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  ExportExcel(data, dosya_ismi: string) {
    return new Promise((res, err) => {
      if (data.length > 0) {
        dosya_ismi = dosya_ismi 
        json2excel({
          data,
          name: dosya_ismi,
          formateDate: 'yyyy/mm/dd'
        });
        res();
      }
      else
        err();
    })
  }
  get storageCihazBilgisiGetir():any{
    return JSON.parse(localStorage.getItem("cihaz"));

  };
  storagecihazrefresh()
  {
    localStorage.removeItem("cihaz");
  }
  storagecihazkontrol(cihaz:any){
    localStorage.setItem("cihaz",JSON.stringify(cihaz));
  }

  public get ServisUrl() {
    return this.storageServisBilgisiGetir.ADRES
      + "/Api/Servis.aspx?key=N9ySoNLaS2_18&t=";
  }

  public InternetConnection() {
    //var networkState = navigator.connection.type;

    // return Network.type;
  }

  showLoadingControl(contentString) {
    let loading = this.loadingCtrl.create({
      content: contentString
    });
    loading.present();
    return loading;
    // this.bllmiktar.syncMiktarBirimDetaylar()
    //   .then(a => {
    //     loading.dismiss();
    //   });
  }

  hideLoadingControl(loadingControl: any) {
    loadingControl.dismiss();
  }
  showBasicAlert(baslik: string, mesaj: string) {
    let alert = this.alert.create({
      title: baslik,
      subTitle: mesaj,
      buttons: ['Tamam']
    });
    alert.present();

  }
  showConfirmAlert(baslik: string, mesaj: string) {
    return new Promise((kabul, ret) => {
      let confirm = this.alert.create({
        title: baslik,
        message: mesaj,
        buttons: [

          {
            text: 'Evet',
            handler: () => {
              kabul();
            }
          },
          {
            text: 'Hayır',
            // handler: () => {
            //   ret();
            // }
          }
        ]
      });
      confirm.present();
    })

  }
  showConfirmAlert2(baslik: string, mesaj: string) {
    return new Promise((kabul, ret) => {
      let confirm = this.alert.create({
        title: baslik,
        message: mesaj,
        buttons: [

          {
            text: 'Evet',
            handler: () => {
              kabul();
            }
          },
          {
            text: 'Hayır',
            handler: () => {
              ret();
            }
          }
        ]
      });
      confirm.present();
    })

  }
  presentToast(mesaj, duration) {
    let toast = this.toastCtrl.create({
      message: mesaj,
      duration: duration,
      showCloseButton: true,
      closeButtonText: Ortak.dilKaynaklari["tamam"],
      position: 'top'
    });
    toast.present();
    // this.sonEklenen = mesaj;
  }
  storagePersonelEkle(personel: any) {


    localStorage.setItem("personel", JSON.stringify(personel));

  };
  staccountadd(acc:any)
  {
    localStorage.setItem("acc",JSON.stringify(acc));
  }

  get storagePersonelGetir(): any {

    return JSON.parse(localStorage.getItem("personel"));
  };
  get staccountget():any{
    return JSON.parse(localStorage.getItem("acc"));
  }
   staccountdel()
  {
localStorage.removeItem("acc");
  }
  storeagePersonelCikar() {

    localStorage.removeItem("personel");
  };
  storageServisAdresiSil()
  {
    localStorage.removeItem("servisBilgisi");
  }

  showErrorAlert() {
    let alert = this.alert.create({
      title: "Hata",
      subTitle: "İşlem sırasında hata oluştu",
      buttons: ['Tamam']
    });
    alert.present();
  }
  get storageServisBilgisiGetir(): NL_Servis {

    return JSON.parse(localStorage.getItem("servisBilgisi"));

  };
  get StAyarGetir(): NL_ProgramAyarlari {
    return JSON.parse(localStorage.getItem("ayarbilgisi"))
  }
  get storagekullanicigetir(): KullaniciType {
    return JSON.parse(localStorage.getItem("kullanicibilgisi"));

  };
  get storageGunTarihiGetir(): any {
    // return this.storage.get('personel').then((value) => {
    //   return JSON.parse(value);
    // });
    return localStorage.getItem("gunTarihi");
  };
  get storageSunucuAdresiGetir(): any {

    return this.storageServisBilgisiGetir.ADRES;
  };

  storageGunTarihiEkle(gunTarihi) {

    // this.storage.set("personel", JSON.stringify(personel));
    localStorage.setItem("gunTarihi", gunTarihi);

  };
  storageServisBilgisiEkle(servisBilgisi) {

    //this.storage.set("servisBilgisi", JSON.stringify(servisBilgisi));
    localStorage.setItem("servisBilgisi", JSON.stringify(servisBilgisi));
  }
  storageProgramAyarEkle(ayarbilgisi) {
    localStorage.setItem("ayarbilgisi", JSON.stringify(ayarbilgisi));
  }
  storagekullaniciekle(kullanicibilgisi) {
    localStorage.setItem("kullanicibilfisi", JSON.stringify(kullanicibilgisi));
  }
alertSubeKaydet()
{
  return new Promise((res,err)=>{
    let prompt=this.alert.create({
      title:"Şube Ekle",
      message:"",
      inputs: [
     
        {
          name: 'subeadi',
          placeholder: "Şube Adı",
        },
        {
          name: 'subeadres',
          placeholder: "Şube sunucu adresi",
          type: "text",
        }

      ],

      buttons: [
        {
          text: 'İptal',
          role: 'cancel',
          handler: data => {

          }
        },
        {
          text: 'Tamam',
          handler: data => {
            // sonuc = true;
            res({ values: data });
          }
        }
      ]
    });
    prompt.present();
  
  })
}
  alertalisfaturakaydet(tarih) {
    return new Promise((res, err) => {
      // var sonuc = false;
      let prompt = this.alert.create({
        title: "Fatura Özellikleri",
        message: "",
        inputs: [
          {
            placeholder: "Alt Satırdan Vade Tarihi Seçiniz..",
          },
          {
            name: 'vadetarih',
            placeholder: "Vade Tarihi",

            type: "date",
            value: tarih
          },
          {
            name: 'aciklama',
            placeholder: "Fatura açıklaması varsa giriniz..",
            type: "text",
          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }

  alertSiparisKalemGuncelle(detay) {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
        title: detay.UrunName,
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: "Miktar:" + " " + detay.Miktar,
            type: "number",
            value:detay.Miktar


          },
          {
            name: 'fiyat',
            placeholder: "Alış Fiyatı:" + " " + detay.BirimFiyat,
            type: "number",
            value:detay.BirimFiyat


          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertKalemGuncelle(hareket) {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
        title: hareket.StokAdi,
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: "Miktar:" + " " + hareket.Miktar,
            type: "number",


          },
          {
            name: 'fiyat',
            placeholder: "Fiyatı:" + " " + hareket.BirimFiyat,
            type: "number",


          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  TurkishToEnglish(phrase) {
    var returnString: string = phrase;

    //Convert Characters
    returnString = returnString.replace(/ö/g, 'o');
    returnString = returnString.replace(/ç/g, 'c');
    returnString = returnString.replace(/ş/g, 's');
    returnString = returnString.replace(/ı/g, 'i');
    returnString = returnString.replace(/ğ/g, 'g');
    returnString = returnString.replace(/ü/g, 'u');
    returnString = returnString.replace(/Ö/g, 'O');
    returnString = returnString.replace(/Ç/g, 'C');
    returnString = returnString.replace(/Ş/g, 'S');
    returnString = returnString.replace(/İ/g, 'I');
    returnString = returnString.replace(/Ğ/g, 'G');
    returnString = returnString.replace(/Ü/g, 'U');
    return returnString;
  }
  formatMoney(girdi, fractionDigits?, decimal?, separator?) {
    if (fractionDigits == null)
      fractionDigits = 2;
    if (decimal == null)
      decimal = ",";
    if (separator == null)
      separator = ",";
    fractionDigits = isNaN(fractionDigits = Math.abs(fractionDigits)) ? 2 : fractionDigits;

    decimal = typeof (decimal) === "undefined" ? "." : decimal;

    separator = typeof (separator) === "undefined" ? "," : separator;

    var number = girdi;

    var neg = number < 0 ? "-" : "";

    var wholePart: any = parseInt(number = Math.abs(+number || 0).toFixed(fractionDigits)) + "";

    var separtorIndex = (separtorIndex = wholePart.length) > 3 ? separtorIndex % 3 : 0;

    return neg +

      (separtorIndex ? wholePart.substr(0, separtorIndex) + separator : "") +

      wholePart.substr(separtorIndex).replace(/(\d{3})(?=\d)/g, "$1" + separator) +

      (fractionDigits ? decimal + Math.abs(number - wholePart).toFixed(fractionDigits).slice(2) : "");


  }
  alertAktarimPenceresi(detay) {

    return new Promise((res, err) => {
      let prompt = this.alert.create({
        title: "Miktar ve Alış fiyatını giriniz.",
        message: "İşleme devam edebilmek için gerekli miktarları giriniz.Kdv Hariç Hesaplanır.",
        inputs: [
          {
            name: 'Miktar',
            placeholder: 'Miktarı Giriniz.',
            type: 'number',

          },
          {
            name: 'Fiyat',
            placeholder: 'Alış Fiyatını Giriniz.',
            type: 'number',
            value: detay.Price1,
          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            role: 'submit',
            handler: data => {
              res({ values: data });
            }
          }
        ]
      });
      prompt.present();
    })
  }
  alertSatisAktarimPenceresi(detay) {

    return new Promise((res, err) => {
      let prompt = this.alert.create({
        title: "Miktar ve Satış fiyatını giriniz.",
        message: "1.Miktar 2.Satış Fiyatı",


        inputs: [
          {
            name: 'Miktar',
            placeholder: 'Miktarı Giriniz.',
            type: 'number',

          },


          {
            name: 'Fiyat',
            placeholder: 'Satış Fiyatını Giriniz.',
            type: 'number',
            value: detay.Price2,

          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            role: 'submit',
            handler: data => {
              res({ values: data });
            }
          }
        ]
      });
      prompt.present();
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/ortak.ts